import React from 'react';
import { observer } from 'mobx-react';
import { Icon } from 'components/Icon';
import { Select, MultiSelect } from 'components/Select';
import { SearchInput } from 'components/SearchInput';
import pageStore from 'stores/Page/Integrations/IntegrationsPageStore';

import * as utils from 'Utils';
import * as constants from 'Constants';
import './styles.scss';


@observer
class IntegrationsItem extends React.Component {
  constructor (props) {
    super(props);
  }

  getCategory = () => {
    const { integration } = this.props;
    const listing = integration.listing;
    let option = pageStore.categoryOptions.filter((option) => option.id === listing.categoryOptionId)[0];
    if (!option) return;
    return option.label;
  };

  render() {
    const { integration } = this.props;
    const listing = integration.listing;
    const deal = integration.deal;

    return (
      <a href={`/integrations/${integration.slug}`} className="integrations-item">
        <img
          src={listing.logoMedia.src}
          className="integrations-item-logo"
        />

        <div className="integrations-item-name">{integration.name}</div>
        <div className="integrations-item-category">{this.getCategory()}</div>
        <div className="integrations-item-tagline">{listing.tagline}</div>

        {deal.offer ? (
          <div className="integrations-item-deal">{deal.offer}</div>
        ): null}
      </a>
    );
  }
}

export default IntegrationsItem;
